module.exports = __webpack_public_path__ + "img/logo-general.829f4e9f.svg";